import { useComebackUrl } from "@/components/hooks/use-comeback-url";
import {
  type LoginFormData,
  login as loginAction,
} from "@/server/actions/members/login/login";
import { pagesPath } from "@/utils/pages-path";
import { useRouter } from "next/navigation";
import { useCallback } from "react";

export function useLogin() {
  const { getComebackUrl } = useComebackUrl();
  const router = useRouter();
  const login = useCallback(
    async (data: LoginFormData) => {
      const result = await loginAction(data);
      if (!result.success) {
        return result.error;
      }

      const url = getComebackUrl() ?? pagesPath.members.$url().path;
      router.push(url);
    },
    [getComebackUrl, router],
  );

  return login;
}
